var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16.1998 8.9998c0 3.9765-3.2236 7.2-7.20001 7.2-3.97644 0-7.19999-3.2235-7.19999-7.2 0-3.97645 3.22355-7.2 7.19999-7.2 3.97641 0 7.20001 3.22355 7.20001 7.2zm-5.4-2.7c0 .99412-.8059 1.8-1.80001 1.8s-1.8-.80588-1.8-1.8c0-.99411.80589-1.8 1.8-1.8s1.80001.80589 1.80001 1.8zm-1.80007 3.60001c-1.81579 0-3.38038 1.07549-4.09157 2.62419.99026 1.1486 2.45602 1.8758 4.09161 1.8758 1.63553 0 3.10133-.7271 4.09153-1.8758-.7111-1.5487-2.2758-2.62419-4.09157-2.62419z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a89075404262b40bca7cf2e84f8c510d.svg";
export { ForwardRef as ReactComponent };